<script lang="ts" setup>
import { useSchemaOrg, defineWebPage } from '@unhead/schema-org/vue';
import { useSdk } from '~/sdk';

const { locale, t } = useI18n();
const route = useRoute();

const { data } = await useAsyncData('page-' + locale.value + '-' + route.params.slug, async () => {
  return useSdk().cms.getContent({
    entry: {
      section: 'pages',
      slug: route.params.slug,
    },
  });
});

if (!data.value) {
  throw createError({
    statusCode: 404,
    message: t('Page not found'),
  });
}

useSeoMeta({
  title: data.value?.seo?.title,
  description: data.value?.seo?.description,
  ogTitle: data.value?.seo?.title,
  ogDescription: data.value?.seo?.description,
});

useSchemaOrg([
  defineWebPage({
    title: data.value?.seo?.title,
    description: data.value?.seo?.description,
    image: data.value?.seo?.image,
  }),
]);

const components = computed(() => {
  return data.value?.components ?? [];
});
</script>

<template>
  <div
    class="space-y-16"
    :class="components && components.length > 0 && components[0].__typename == 'carousel-block' ? '' : 'py-16'"
  >
    <BlockRenderer :components="components" />
  </div>
</template>
